export default function CopyIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.168 13.4V16.4C17.168 20.4 15.568 22 11.568 22H7.76797C3.76797 22 2.16797 20.4 2.16797 16.4V12.6C2.16797 8.6 3.76797 7 7.76797 7H10.768"
        stroke="#FDFDFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.1695 13.4H13.9695C11.5695 13.4 10.7695 12.6 10.7695 10.2V7L17.1695 13.4Z" stroke="#FDFDFF" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.7695 2H15.7695" stroke="#FDFDFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.16797 5C7.16797 3.34 8.50797 2 10.168 2H12.788" stroke="#FDFDFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.1694 8V14.19C22.1694 15.74 20.9094 17 19.3594 17" stroke="#FDFDFF" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M22.168 8H19.168C16.918 8 16.168 7.25 16.168 5V2L22.168 8Z" stroke="#FDFDFF" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
  )
}
